module.exports = __webpack_public_path__ + "img/_wroking_hours.0d20c88f.svg";